<template>
  <div>
    <v-card class="mx-auto pa-2" max-width="100%" elevation="1" outlined>
      <v-container fluid no-gutters>
        <v-row>
          <v-col align="center" no-gutters>
            <h4>
              <div class="graph-title">{{ heading }}</div>
            </h4>
            <v-btn
              fab
              absolute
              top
              right
              x-small
              elevation="1"
              @click="fullscreen"
            >
              <v-icon>mdi-fullscreen</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <column-chart
        :data="chartData"
        :dataset="{ borderWidth: 2 }"
        :colors="colors"
        :ytitle="yTitle"
        :xtitle="xTitle"
        :library="chartOptions"
      ></column-chart>
    </v-card>
    <v-dialog v-model="dialog" max-width="90%" @input="closeEvent">
      <div v-if="fullscreenFlag">
        <v-card class="mx-auto pa-2" max-width="100%" elevation="1" outlined>
          <v-container fluid no-gutters>
            <v-row>
              <v-col align="center" no-gutters>
                <h4>
                  <div class="graph-title">{{ heading }}</div>
                </h4>
              </v-col>
            </v-row>
            <v-row no-gutters pa-0 ma-0>
              <!----------Column 1 Start    ----------------  -->
              <v-col
                align="left"
                cols="5"
                md="5"
                no-gutters
                v-if="typeof clientName != 'undefined' && clientName.length > 0"
              >
                <div class="client">
                  <v-select
                    v-model="selectedClients"
                    :items="clientName"
                    @input="limiter"
                    item-value="id"
                    item-text="venue_name"
                    label="Client"
                    multiple
                    small-chips
                    @change="emitChange"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.venue_name }}</span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.venue_name }}</span>
                      </v-chip>
                      <span v-if="index === 2" class="grey--text caption"
                        >(+{{ selectedClients.length - 2 }} others)</span
                      >
                    </template>
                  </v-select>
                </div>
              </v-col>

              <v-col
                align="left"
                cols="4"
                md="4"
                no-gutters
                v-else-if="!hideDateNavigation"
              >
                <v-btn-toggle
                  dense
                  borderless
                  color="rgb(102, 200, 200)"
                  class="date_button_navigation"
                  v-model="toggle_mode"
                  @change="changeMode"
                  mandatory
                >
                  <v-btn value="day">Day</v-btn>
                  <v-btn value="month">Month</v-btn>
                  <v-btn value="year">Year</v-btn>
                </v-btn-toggle>
              </v-col>
              <v-spacer></v-spacer>
              <v-col align="center" cols="4" md="4">
                <v-row no-gutters pa-0 ma-0>
                  <v-spacer></v-spacer>
                  <!----------Column 1 Start    ----------------  -->
                  <v-col align="center" cols="10" md="10" v-if="dayClick">
                    <div class="pickers mr-4">
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-menu
                            v-model="dateMenu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                solo
                                dense
                                class="text1"
                                v-model="date1Formatted"
                                readonly
                                v-on="on"
                                filled
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateDay1"
                              @input="dateMenu1 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs6>
                          <v-menu
                            v-model="dateMenu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                class="text2"
                                v-model="date2Formatted"
                                solo
                                dense
                                readonly
                                v-on="on"
                                filled
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateDay2"
                              @input="dateMenu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-col>
                  <v-col align="center" cols="10" md="10" v-if="monthClick">
                    <div class="pickers mr-4">
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-menu
                            v-model="monthMenu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                solo
                                dense
                                class="text1"
                                v-model="dateMonth1Formatted"
                                readonly
                                v-on="on"
                                filled
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateMonth1"
                              type="month"
                              @input="monthMenu1 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs6>
                          <v-menu
                            v-model="monthMenu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                class="text2"
                                v-model="dateMonth2Formatted"
                                solo
                                dense
                                readonly
                                v-on="on"
                                filled
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateMonth2"
                              type="month"
                              @input="monthMenu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-col>
                  <v-col align="center" cols="10" md="10" v-if="yearClick">
                    <div class="pickers mr-4">
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-select
                            v-model="dateYear1"
                            :items="getYears"
                            height="27"
                            solo
                            dense
                            filled
                          ></v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            v-model="dateYear2"
                            :items="getYears"
                            height="27"
                            solo
                            dense
                            filled
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-col>
                  <v-col md="1"
                    ><v-btn
                      dense
                      small
                      height="32px"
                      color="#00b0af"
                      @click="emitChange"
                      dark
                      >Go</v-btn
                    ></v-col
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-container>

          <column-chart
            :data="chartData"
            :dataset="{ borderWidth: 3 }"
            :colors="colors"
            :ytitle="yTitle"
            :xtitle="xTitle"
            :library="chartOptions"
          ></column-chart>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    type: String,
    heading: String,
    chartData: Array,
    yTitle: String,
    xTitle: String,
    clientName: Array,
    hideDateNavigation: { type: Boolean, default: false },
    changeID: { type: Number, default: 0 },
    colors: {
      type: Array,
      default: () => [
        "rgb(44, 59, 70)",
        "rgb(0, 177, 176)",
        "rgb(255, 192, 0)",
        "rgb(123, 127, 129)",
        "rgb(126, 110, 77)",
        "rgb(14, 103, 171)",
        "rgb(109, 139, 163)",
      ],
    },
    heighest: { type: Number },
    eventFilter: { type: Boolean, default: false },
  },
  data() {
    return {
      toggle_mode: "day",
      dialog: false,
      fullscreenFlag: false,
      fullscreenBtn: true,
      chartOptions: {
        tooltips: { enabled: true },
        hover: { mode: null },
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMax: 2,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: function(context) {
              return context.dataset.data[context.dataIndex] !== 0;
            },
            color: "#066a8c",
            align: "end",
            anchor: "end",
            font: {
              size: 11,
              weight: 700,
            },
            offset: 8,
          },
        },
      },
      selectedClients: [],
      dateDay1: moment()
        .subtract(10, "days")
        .format("YYYY-MM-DD"),
      dateDay2: moment().format("YYYY-MM-DD"),

      dateMonth1: moment()
        .subtract(1, "months")
        .format("YYYY-MM"),
      dateMonth2: moment().format("YYYY-MM"),

      dateYear1: parseInt(
        moment()
          .subtract(1, "year")
          .format("YYYY")
      ),
      dateYear2: parseInt(moment().format("YYYY")),

      dateMenu1: false,
      dateMenu2: false,
      monthMenu1: false,
      monthMenu2: false,
      dayClick: true,
      monthClick: false,
      yearClick: false,
    };
  },
  watch: {
    changeID(val) {
      if (val != 0) {
        this.emitChange();
      }
    },
    heighest(val) {
      this.chartOptions.scales.yAxes[0].ticks.suggestedMax = val;
    },
  },
  computed: {
    getYears() {
      const currentYear = new Date().getFullYear();
      const range = (start, stop, step) =>
        Array.from(
          { length: (stop - start) / step + 1 },
          (_, i) => start + i * step
        );
      return range(currentYear, currentYear - 50, -1);
    },
    date1Formatted() {
      return moment(String(this.dateDay1)).format("DD-MM-YYYY");
    },
    date2Formatted() {
      return moment(String(this.dateDay2)).format("DD-MM-YYYY");
    },
    dateMonth1Formatted() {
      return moment(String(this.dateMonth1)).format("MMM-YYYY");
    },
    dateMonth2Formatted() {
      return moment(String(this.dateMonth2)).format("MMM-YYYY");
    },
  },

  methods: {
    changeMode() {
      if (this.toggle_mode == "day") {
        this.dayClick = true;
        this.monthClick = false;
        this.yearClick = false;
        this.emitChange();
      } else if (this.toggle_mode == "month") {
        this.dayClick = false;
        this.monthClick = true;
        this.yearClick = false;
        this.emitChange();
      } else if (this.toggle_mode == "year") {
        this.dayClick = false;
        this.monthClick = false;
        this.yearClick = true;
        this.emitChange();
      }
    },
    limiter(e) {
      if (e.length > 4) {
        this.$toast.error("You can only select 4 Venues at a time", {
          timeout: 10000,
          icon: "mdi-thumb-down",
          dismissable: true,
          showClose: true,
          closeText: "",
          closeIcon: "mdi-close-thick",
          closeColor: "white",
          queueable: true,
        });
        e.pop();
      }
    },
    emitChange() {
      if (this.toggle_mode == "day") {
        if (
          moment(String(this.dateDay2), "YYYY-MM-DD").diff(
            moment(String(this.dateDay1), "YYYY-MM-DD"),
            "days"
          ) > 30 &&
          this.clientName.length == 0
        ) {
          this.$toast.error("Date range should be less than 31 days", {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
          return false;
        }
        this.$emit("chartChangeEvent", {
          type: "day",
          chart: this.type,
          from: moment(String(this.dateDay1), "YYYY-MM-DD").format(
            "DD/MM/YYYY"
          ),
          to: moment(String(this.dateDay2), "YYYY-MM-DD").format("DD/MM/YYYY"),
          clients: this.selectedClients,
        });
      } else if (this.toggle_mode == "month") {
        this.$emit("chartChangeEvent", {
          type: "month",
          chart: this.type,
          from: this.dateMonth1Formatted,
          to: this.dateMonth2Formatted,
          clients: this.selectedClients,
        });
      } else if (this.toggle_mode == "year") {
        this.$emit("chartChangeEvent", {
          type: "year",
          chart: this.type,
          from: this.dateYear1,
          to: this.dateYear2,
          clients: this.selectedClients,
        });
      }
    },
    fullscreen() {
      this.dialog = true;
      this.fullscreenFlag = true;
    },
    closeEvent() {
      this.dialog = false;
      this.fullscreenFlag = false;
    },
  },
};
</script>

<style scoped>
.date_button_navigation {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.date_button_navigation .v-item--active {
  background-color: #062b48 !important;
  color: #fff !important;
}
</style>
